
/* 1. header-03 */
var appendPrependMenuMobile = function() {
    var headerPC = $('.wrapper-header .header-pc'),
        wrapperHeaderBt = $('.wrapper-header-bt'),
        wrapperNav = $('.wrapper-navigation'),
        areaMb = wrapperNav.find('.mb-area');

    if (window.innerWidth < 1200) {
        headerPC.appendTo(areaMb);
    } else {
        headerPC.appendTo(wrapperHeaderBt);
    };
};

$(document).ready(function() {
    appendPrependMenuMobile();
});

var winWidth = $(window).innerWidth();

$(window).on('resize', function () {
    var resizeTimerId;

    clearTimeout(resizeTimerId);

    resizeTimerId = setTimeout(function() {
        var curWinWidth = $(window).innerWidth();

        if ((curWinWidth < 1200 && winWidth >= 1200) || (curWinWidth >= 1200 && winWidth < 1200)) {
            appendPrependMenuMobile();
        };
        winWidth = curWinWidth;
    }, 0);
});

if (window.multi_lang) {
    translator.doTranslate('.site-header');
}



/* 2. product ymal */
(function ($) {
  $(document).ready(function(){
    if (!$("#div_you_may_also_like").length) {
      return;
    }
    var collectionHandle = ellaEx.getUrlParameter('ymal');
    if (collectionHandle) {
      $("#product-recommendations").hide();
      $.ajax({
        type: "get",
        url: '/collections/' + collectionHandle + '?view=ymal',
        cache: false,

        success: function (data) {
          $("#div_you_may_also_like").html( data );
          $("#div_you_may_also_like").show();
          ellaEx.init();
        },
        error: function () {
          $("#product-recommendations").show();
        }
      });
    } else{
        $("#product-recommendations").show();
    }
  });

  var ellaEx = {
    init: function() {
      this.initInfiniteScrollingHomepage();
    },

    getUrlParameter: function(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return false;
    },

    initInfiniteScrollingHomepage: function () {
      var newArrivalsProduct = $('[data-ymal-products]');

      newArrivalsProduct.each(function () {
        var self = $(this);
        var infiniteScrolling = self.find('.infinite-scrolling-homepage');
        var infiniteScrollingLinkSlt = self.find('.infinite-scrolling-homepage a');
        
        if (infiniteScrolling.length) {
          infiniteScrollingLinkSlt.off('click.showMoreProduct').on('click.showMoreProduct', function (e) {
            if (!$(this).hasClass('view-all-collection')) {
                e.preventDefault();
                e.stopPropagation();
                if($(this).hasClass('ajax-loading') )
                  return false;
                $(this).addClass('ajax-loading');
                var url = $(this).attr('data-collection'),
                    limit = $(this).attr('data-limit'),
                    totalProduct = $(this).attr('data-total-products'),
                    page = parseInt($(this).attr('data-page'));

                if (!$(this).hasClass('disabled')) {
                  ellaEx.doAjaxInfiniteScrollingGetContentSection(totalProduct, url, limit, page, e, self);
                };
            }
          });
        }
      });
    },

    doAjaxInfiniteScrollingGetContentSection: function(totalProduct, url, limit, page, e, self) {
      $.ajax({
        type: "get",
        url: window.router + '/collections/' + url,
        cache: false,
        data: {
          view: 'sorting',
          limit,
          page,
        },

        beforeSend: function () {
          $('.loading-modal').show();
        },
        success: function (data) {
            self.find('.products-grid').append(data);
            var length = self.find('.products-grid').find('.grid-item').length;
            if( $(data).length == limit && length < 50){
                $(e.currentTarget).attr('data-page', page + 1);
            }
            else{
                if (totalProduct > 50) {
                    $(e.currentTarget).text(window.inventory_text.view_all_collection).attr('href',window.router + '/collections/' + url).addClass('view-all-collection');
                } else {
                    $(e.currentTarget).remove();
                }
            }
          
            if (ellaEx.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            };
            $('[data-toggle="tooltip"]').tooltip();
        },
        complete: function () {
          $('.loading-modal').hide();
          $(e.currentTarget).removeClass('ajax-loading');
          $('[data-toggle="tooltip"]').tooltip();
        }
      });
    },

    checkNeedToConvertCurrency: function () {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    },
 
  };

})(jQuery);



/* 3. home slider init */
(function ($) {
  $(document).ready(function () {
      //init_home_blog_posts
      $('[data-home-blog-posts]').each(function () {
          var self = $(this),
          rows = self.data('rows');
          if(self.not('.slick-initialized')) {
              self.slick({
                  slidesToShow  : rows,
                  slidesToScroll: rows,
                  speed         : 1000,
                  autoplay      : false,
                  infinite      : true,
                  arrows        : true,
                  dots          : false,
                  get nextArrow() {
                      return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
                  },
                  get prevArrow() {
                      return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
                  },
                  responsive: [
                      {
                          breakpoint: 992,
                          settings: {
                            slidesToShow  : 2,
                            slidesToScroll: 2,
                          }
                      }
                  ]
              });
          };
      });

      //init_home_customer_reviews
      $('[data-review-slider]').each(function () {
          var self = $(this),
          rows = self.data('row');

          if (self.not('.slick-initialized')) {
              self.slick({
                  slidesToShow  : rows,
                  slidesToScroll: rows,
                  autoplay      : false,
                  dots          : false,
                  arrows        : true,
                  speed         : 800,
                  get nextArrow() {
                      return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
                  },
                  get prevArrow() {
                      return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
                  },
                  responsive: [
                      {
                          breakpoint: 992,
                          settings: {
                              slidesToScroll: 2,
                              slidesToShow: 2,
                              dots: true,
                          }
                      },
                      {
                          breakpoint: 768,
                          settings: {
                              slidesToScroll: 1,
                              slidesToShow: 1,
                              dots: true,
                          }
                      }
                  ]
              });
          }
      });

  });


  var haloHome = {
    initSlideshow: function () {
        var slickSlideshow = $('.has-sliders [data-init-slideshow]');

        if (slickSlideshow.length) {
            slickSlideshow.each(function () {
                var self = $(this);

                if (self.not('.slick-initialized')) {
                    self.slick({
                        dots: self.data('dots'),
                        slidesToScroll: 1,
                        verticalSwiping: false,
                        fade: self.data('fade'),
                        cssEase: "ease",
                        adaptiveHeight: true,
                        autoplay: self.data('autoplay'),
                        autoplaySpeed: self.data('autoplay-speed'),
                        arrows: self.data('arrows'),
                        get nextArrow() {
                                return this.nextArrow = '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>';
                        },
                        get prevArrow() {
                                return this.prevArrow = '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>';
                        },
                        responsive: [{
                            breakpoint: 1280,
                            settings: {
                                arrows: false,
                                dots: self.data('dots'),
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: false,
                                dots: true
                            }
                        }
                        ]
                    });
                };
            });
        };
    },

    initNewArrivalsAdv: function() {
      if (!$('[data-home-new-arrivals-adv]').length) {
        return;
      }
      if ($(window).width() >= 1200) {
        $('[data-home-new-arrivals-adv] .grid-item-banner').remove();
      } else {
        var height = $('[data-home-new-arrivals-adv] .grid-item:nth-child(2)').height();
        $('[data-home-new-arrivals-adv] .grid-item-banner').height(height);
      }
      $('[data-home-new-arrivals-adv]').each(function () {
        var productGrid = $(this).find('.products-grid');
        if (productGrid.not('.slick-initialized')) {
          productGrid.slick({
            slidesToShow  : productGrid.data('row'),
            slidesToScroll: productGrid.data('row'),
            dots          : false,
            arrows        : true,
            speed         : 1000,
            get nextArrow() {
                return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
            },
            get prevArrow() {
                return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
            },
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow  : 4,
                  slidesToScroll: 4,
                  dots          : true,
                  arrows        : false,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow  : 3,
                  slidesToScroll: 3,
                  dots          : true,
                  arrows        : false,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow  : 2,
                  slidesToScroll: 2,
                  dots          : true,
                  arrows        : false,
                }
              }
            ]
          });
        }
      });
    },

    initHomeWeeklyDeals: function() {
      if (!$('[data-home-weekly-deals]').length) {
        return;
      }
      $('[data-home-weekly-deals]').each(function () {
        var layout = $(this).data('layout');
        if (layout != 'carousel') {
            return;
        }

        var productGrid = $(this).find('.products-grid');
        if (productGrid.not('.slick-initialized')) {
          productGrid.slick({
            slidesToShow  : productGrid.data('row'),
            slidesToScroll: productGrid.data('row'),
            speed         : 1000,
            infinite      : false,
            dots          : false,
            get nextArrow() {
                return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
            },
            get prevArrow() {
                return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
            },
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow  : 4,
                  slidesToScroll: 4,
                  dots          : true,
                  arrows        : false,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow  : 3,
                  slidesToScroll: 3,
                  dots          : true,
                  arrows        : false,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow  : 2,
                  slidesToScroll: 2,
                  dots          : true,
                  arrows        : false,
                }
              }
            ]
          });
        };
      });
    },
 
    initInstagramSlider: function () {
        var instagramBlock = $('[data-instagram-feed]');
  
        instagramBlock.each(function () {
          var self = $(this),
            dataRows = self.data('rows'),
            dataSlideRow = self.data('slide-rows'),
            dataArrow = self.data('arrow'),
            dataMode = self.data('mode'),
            dataLimit = self.data('limit');
  
          if (dataSlideRow == 2) {
            var x = self.children();
  
            for (i = 0; i < x.length; i += 2) {
              x.slice(i, i + 2).wrapAll('<div class="' + i + '"></div>');
            }
          }
  
          self.slick({
            infinite: true,
            speed: 1000,
            centerMode: dataMode,
            get centerPadding() {
              if (dataMode == true) {
                return this.centerPadding = '11.36%';
              }
            },
            arrows: dataArrow,
            get nextArrow() {
              return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
            },
            get prevArrow() {
              return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
            },
            slidesToShow: dataRows,
            slidesToScroll: dataRows,
            responsive: [{
                breakpoint: 1200,
                settings: {
                  get slidesPerRow() {
                    if (dataSlideRow == 2) {
                      this.slidesPerRow = 1,
                        this.rows = 2
                    }
                  },
                  get slidesToScroll() {
                    if (dataSlideRow == 1) {
                      return this.slidesToScroll = 4
                    }
                  },
                  slidesToShow: 4
                }
              },
              {
                breakpoint: 992,
                settings: {
                  get slidesPerRow() {
                    if (dataSlideRow == 2) {
                      this.slidesPerRow = 1,
                        this.rows = 2
                    }
                  },
                  get slidesToScroll() {
                    if (dataSlideRow == 1) {
                      return this.slidesToScroll = 3
                    }
                  },
                  slidesToShow: 3
                }
              },
              {
                breakpoint: 768,
                settings: {
                  get slidesPerRow() {
                    if (dataSlideRow == 2) {
                      this.slidesPerRow = 1,
                        this.rows = 2
                    }
                  },
                  get slidesToScroll() {
                    if (dataSlideRow == 1) {
                      return this.slidesToScroll = 2
                    }
                  },
                  slidesToShow: 2
                }
              }
            ]
          });
        });
    }
  };
  haloHome.initSlideshow();
  haloHome.initNewArrivalsAdv();
  haloHome.initHomeWeeklyDeals();
  haloHome.initInstagramSlider();


  var haloPage = {
    initFeaturedProducts1: function() {
      if (!$('[data-featured-products-1]').length) {
        return;
      }
      $('[data-featured-products-1]').each(function () {
        var layout = $(this).data('layout');
        if (layout != 'carousel') {
            return;
        }
  
        var productGrid = $(this).find('.products-grid');
        if (productGrid.not('.slick-initialized')) {
          productGrid.slick({
            slidesToShow  : productGrid.data('row'),
            slidesToScroll: productGrid.data('row'),
            speed         : 1000,
            infinite      : false,
            dots          : false,
            get nextArrow() {
                return this.nextArrow = '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>';
            },
            get prevArrow() {
                return this.prevArrow = '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>';
            },
            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow  : 4,
                  slidesToScroll: 4,
                  dots          : true,
                  arrows        : false,
                }
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow  : 3,
                  slidesToScroll: 3,
                  dots          : true,
                  arrows        : false,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow  : 2,
                  slidesToScroll: 2,
                  dots          : true,
                  arrows        : false,
                }
              }
            ]
          });
        };
      });
    }
  };
  haloPage.initFeaturedProducts1();

})(jQuery);






/* 4. search-autocomplete */
(function ($) {
    var pluginName = 'Search',
        namespace = 'plugin_' + pluginName;
  
    function Plugin(element) {
      this.headerSearch = $(element);
      this.headerSearchForm = this.headerSearch.find('.header-search__form');
      this.headerInput = this.headerSearch.find('.header-search__input');
      this.headerSearchResults = this.headerSearch.find('.header-search__results-wrapper');
      this.searchResultsTemplate = Template7.compile($('#search-results-template').html());
      this.PopularProducts = this.headerSearch.find(".header-search__product");
      this.searchMode = "product";
      this.searchTrending = $(".quickSearchResultsWrap .header-search__trending .item");
      this.trending = $(".header-search__trending");
      this.searchWrapper = this.headerSearch.find('.quickSearchResultsWrap');
  
      this.headerInput.focus(function(e){
        e.stopPropagation();
  
        $(this).closest('.header-search').find('.quickSearchResultsWrap').show();
      });
  
      $(document).mouseup(function (e) {
        var container = $(".search-form");
  
        if (!container.is(e.target) && container.has(e.target).length === 0){
          container.find('.quickSearchResultsWrap').hide();
        }
      });
  
      this.headerInput.on('focusin', $.proxy(this._focusin, this));
  
  
      this.headerInput.on('keyup', $.proxy(this._initSearch, this));
    };
  
    Plugin.prototype._initSearch = function(event) {
      var target = $(event.currentTarget);
  
      if ((event.keyCode ? event.keyCode : event.which) != 13) {
        clearTimeout(target.data('timeout'));
        target.data('timeout', setTimeout($.proxy(this._doSearch, this), 250));
      }
    };
  
    Plugin.prototype._doSearch = function(event) {
  
      if (this.headerInput.val().trim() === '') {
        this.headerSearchResults.empty();
        this.searchTrending.show();
        this.PopularProducts.show();
        this.searchWrapper.show();
        this.trending.show();
  
        return; 
      }
      else {
        this.headerSearchResults.html(this.searchResultsTemplate({is_loading: true}));
      }
  
      if (this.headerInput.val().length > 0) {
        this.searchWrapper.hide();
        this._doCompleteSearch();
      }
      else {
        this.headerSearchResults.html(this.searchResultsTemplate({is_show: false}));
        this.searchTrending.show();
        this.PopularProducts.show();
        this.searchWrapper.show();
      }
  
      if(this.searchTrending.css('display') == 'none') {
        this.trending.hide();
      } else {
        this.trending.show();
      }
    };
  
    Plugin.prototype._doCompleteSearch = function(event) {
      var self = this;
  
      $.ajax({
        method: 'GET',
        url: window.router + '/search?view=ajax',
        dataType: 'json',
        data: {
          q: this.headerInput.val() + '*',
          type: this.searchMode
        }
      }).then(function(data) {
  
        self.headerSearchResults.html(self.searchResultsTemplate({
          is_show: true,
          is_loading: false,
          results: data['results'],
          has_results: (data['results'].length > 0),
          results_count: data['results_count'],
          results_label: data['results_label'],
          title_heading: data['title_heading'],
          results_url: (data['url'] + '&type=' + self.searchMode)
        }));
  
        self.PopularProducts.hide();
  
  
        var value = self.headerInput.val().toLowerCase();
        if (data && data.length) {
          self.searchTrending.filter(function(e) {
            $(this).toggle($(this).find('.highlight span').text().toLowerCase().indexOf(value) > -1);
          });
          self.trending.show();
        }
        else {
          self.trending.hide();
        }
  
        self.searchWrapper.show();
      });
    };
  
    $.fn[pluginName] = function(options) {
      var method = false,
          methodArgs = arguments;
  
      if (typeof options == 'string') {
        method = options;
      }
  
      return this.each(function() {
        var plugin = $.data(this, namespace);
  
        if (!plugin && !method) {
          $.data(this, namespace, new Plugin(this, options));
        } else if (method) {
          callMethod(plugin, method, Array.prototype.slice.call(methodArgs, 1));
        }
      });
    };
  }(jQuery));
  
  $(function() {
    $('[data-ajax-search]').Search();
  });
  

/* 5. gtranslate */
function GTranslateGetCurrentLang() {
  var keyValue = document.cookie.match('(^|;) ?googtrans=([^;]*)(;|$)');
  return keyValue ? keyValue[2].split('/')[2] : null;
}

function gt_loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete") {
        script.onreadystatechange = null;
        callback()
      }
    }
  } else {
    script.onload = function () {
      callback()
    }
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script)
}

function googleTranslateElementInit2() {
  new google.translate.TranslateElement({
    pageLanguage: 'en',
    autoDisplay: false
  }, 'google_translate_element2');
}

function GTranslateFireEvent(element, event) {
  try {
    if (document.createEventObject) {
      var evt = document.createEventObject();
      element.fireEvent('on' + event, evt)
    } else {
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent(event, true, true);
      element.dispatchEvent(evt)
    }
  } catch (e) {}
}

function doGTranslate(lang_pair) {
  if (lang_pair.value) lang_pair = lang_pair.value;
  if (lang_pair == '') return;
  var lang = lang_pair.split('|')[1];
  if (GTranslateGetCurrentLang() == null && lang == lang_pair.split('|')[0]) return;
  if (typeof ga == 'function') {
    ga('send', 'event', 'GTranslate', lang, location.hostname + location.pathname + location.search);
  } else {
    if (typeof _gaq != 'undefined') 
      _gaq.push(['_trackEvent', 'GTranslate', lang, location.hostname + location.pathname + location.search]);
  }
  var teCombo;
  var sel = document.getElementsByTagName('select');
  for (var i = 0; i < sel.length; i++)
    if (/goog-te-combo/.test(sel[i].className)) teCombo = sel[i];
  if (document.getElementById('google_translate_element2') == null || 
      document.getElementById('google_translate_element2').innerHTML.length == 0 || 
      teCombo.length == 0 || teCombo.innerHTML.length ==0) {
    setTimeout(function () {
      doGTranslate(lang_pair)
    }, 500)
  } else {
    teCombo.value = lang;
    GTranslateFireEvent(teCombo, 'change');
    GTranslateFireEvent(teCombo, 'change')
  }
}

$(document).ready(function () {
  if (!window.gt_translate_script) {
    window.gt_translate_script = document.createElement('script');
    gt_translate_script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit2';
    document.body.appendChild(gt_translate_script);
  }
  
  var languageItem = $('#languages').find('[data-language]');

  languageItem.on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
      return false;
    }

    /* swtich active class */
    languageItem.removeClass('active');
    $(this).addClass('active');

    var label = $('#languages').prev('[data-language-label]');
    if (label.length) {
      /* change label text */
      label.html($(this).html());
      if (label.is(':visible')) {
        $('#languages').slideUp(300);
      }       
    }

    var lang = $(this).data('language');
    if (lang != GTranslateGetCurrentLang()) {
      doGTranslate('en|' + lang);
    }
  });

  var currLang = GTranslateGetCurrentLang();
  var currOpt = $('#languages')
  .find('a[data-language="' + currLang + '"]');

  if (currOpt.length) {
    /* change label text */
    $('#languages')
    .prev('[data-language-label]')
    .html(currOpt.html());

    /* swtich active class */
    $('#languages')
    .find('a:not([data-language="' + currLang + '"])')
    .removeClass('active');
    currOpt.addClass('active');
  }
});




/* 6. new-currency */
// Select all your currencies buttons.
var currencySwitcher = $('#currencies'),
    currencyItem = currencySwitcher.find('[data-currency]');

currencyItem.on('click', function(e) {
  e.preventDefault();

  if($(this).hasClass('active')) return false;

  currencyItem.removeClass('active');
  $(this).addClass('active');

  var label = $('#currencies').prev('[data-currency-label]');
  if(label.length && label.is(':visible')) {
    var item = $(this).html();
    label.html(item);

    if($('.lang-currency-groups-8').length){
      currencySwitcher.hide();
    } else {
      currencySwitcher.slideUp(300);
    }
  };

  var cur = $(this).attr('data-currency');
  $('#currency_form option').filter(function() { 
    return ($(this).text() == cur); //To select Blue
  }).prop('selected', true);
  $('#currency_form').submit();

});

function AutoScroll(obj, height) {

  $(obj).find("ul:first").animate({
      marginTop: (-1*height)+'px'
  },
  500,
  function() {
      $(this).css({
          marginTop: "0px"
      }).find("li:first").appendTo(this);
  });
}